export default __webpack_public_path__ + "static/media/slide5.a76680e7.png";